// Constants
export const LOGIN_START = "LOGIN_START";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_COMPLETE = "LOGIN_COMPLETE";
export const LOG_OUT = "LOG_OUT";
